import { GlobalContext } from "global/context/Provider";
import React, { useContext, useEffect, useState } from "react";
import PresentismoAyudaIcon from "_+_Portal/assets/images/generico/PresentismoAyudaIcon";
import { PortalContext } from "../../../context/Provider";
import "./PresentismoBox.css";
import Tooltip from "global/component/Genericos/Tooltip/Tooltip";

const PresentismoBox = ({
  consultas,
  pasos,
  modalInfoPresentismo,
  modalTurnosPresentismo,
}) => {
  const { modalState, authState, modalDispatch } = useContext(GlobalContext);
  const { selectDropDownState, textosState } = useContext(PortalContext);

  const [showComponent, setShowComponent] = useState(true);

  const [tipoPresentismo, setTipoPresentismo] = useState(null);
  const [porcentajePresentismo, setPorcentajePresentismo] = useState(null);
  const [habilitadoPresentismoPropio, setHabilitadoPresentismoPropio] = useState(false);

  const [tipoPresentismoFamiliar, setTipoPresentismoFamiliar] = useState(null);
  const [porcentajePresentismoFamiliar, setPorcentajePresentismoFamiliar] =
    useState(null);
  const [habilitadoPresentismo, setHabilitadoPresentismo] = useState(false);

  let config = localStorage.getItem("config");
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;
  let pacienteDropdown =
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente;

  // Setea el porcentaje y el tipo (consulta o practica) sobre el familiar
  useEffect(() => {
    setShowComponent(false);
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      if (consultas === true) {
        setTipoPresentismoFamiliar(
          selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.rankingConsultas
        );
        setPorcentajePresentismoFamiliar(
          selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.turnosConsultasPorcentaje
        );
        setHabilitadoPresentismo(
          ((selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.turnosAusentesConsultas ?? 0) +
            (selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
              ?.paciente?.ausentismo?.turnosPresentesConsultas ?? 0)) >= 10
        );
      } else {
        setTipoPresentismoFamiliar(
          selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.rankingPracticas
        );
        setPorcentajePresentismoFamiliar(
          selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.turnosPracticasPorcentaje
        );
        setHabilitadoPresentismo(
          ((selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
            ?.paciente?.ausentismo?.turnosAusentesPracticas ?? 0) +
            (selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido
              ?.paciente?.ausentismo?.turnosPresentesPracticas ?? 0)) >= 10
        );
      }
      setShowComponent(true);
    }
  }, [
    selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
    consultas, pasos
  ]);

  // Setea el porcentaje y el tipo (consulta o practica) sobre el usuario logueado
  useEffect(() => {
    if (authState?.auth?.data?.paciente?.ausentismo) {
      if (consultas === true) {
        setTipoPresentismo(
          authState?.auth?.data?.paciente?.ausentismo?.rankingConsultas
        );
        setPorcentajePresentismo(
          authState?.auth?.data?.paciente?.ausentismo?.turnosConsultasPorcentaje
        );
        setHabilitadoPresentismoPropio(
          ((authState?.auth?.data?.paciente?.ausentismo?.turnosAusentesConsultas ?? 0) +
            (authState?.auth?.data?.paciente?.ausentismo?.turnosPresentesConsultas ?? 0)) >= 10
        );
      } else {
        setTipoPresentismo(
          authState?.auth?.data?.paciente?.ausentismo?.rankingPracticas
        );
        setPorcentajePresentismo(
          authState?.auth?.data?.paciente?.ausentismo?.turnosPracticasPorcentaje
        );
        setHabilitadoPresentismoPropio(
          ((authState?.auth?.data?.paciente?.ausentismo?.turnosAusentesPracticas ?? 0) +
            (authState?.auth?.data?.paciente?.ausentismo?.turnosPresentesPracticas ?? 0)) >= 10
        );
      }
    }
  }, [consultas, pasos]);

  return (
    <React.Fragment>

      {habilitadoPresentismo && authState?.auth?.data?.paciente?.ausentismo &&
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido &&
        showComponent && (
          <div
            className={`${
              tipoPresentismoFamiliar === "Verde"
                ? "ptur-presentismoBoxVerde-container"
                : tipoPresentismoFamiliar === "Amarillo"
                ? "ptur-presentismoBoxAmarillo-container"
                : (bloqueoPresentismo && !pacienteDropdown.seguimiento) ||
                  (!bloqueoPresentismo && pacienteDropdown.seguimiento)
                ? "ptur-presentismoBoxRojo-container"
                : "ptur-presentismoBoxRojo-container"
            }  c-white`}
          >
            <div className="ptur-presentismoBox-texto1 rb14m">
              <div className="ptur-presentismo-txtIcon">
                Presentismo{" "}
                <div
                  onClick={modalInfoPresentismo}
                  className="ptur-presentismo-iconBox"
                >
                  <PresentismoAyudaIcon />
                </div>
              </div>
              <p>
                {tipoPresentismoFamiliar === "Verde"
                  ? "¡Gracias por tu compromiso!"
                  : tipoPresentismoFamiliar === "Amarillo"
                  ? "Tiene muchos ausentes sin cancelar"
                  : (bloqueoPresentismo && !pacienteDropdown.seguimiento) ||
                    (!bloqueoPresentismo && pacienteDropdown.seguimiento)
                  ? "No puedes solicitar turnos online"
                  : "Tiene muchos ausentes sin cancelar"}
              </p>
            </div>
            <div
              className="ptur-presentismoBox-texto2"
              onClick={modalTurnosPresentismo}
            >
              <Tooltip
                descripcion={"Ver Turnos"}
                data={
                  <>
                    <div className="porcentajeBox">
                      <p className="rb24b">
                        {tipoPresentismoFamiliar === "Verde" ? (
                          <span>
                            {porcentajePresentismoFamiliar === undefined
                              ? ""
                              : porcentajePresentismoFamiliar === 0
                              ? "100%"
                              : porcentajePresentismoFamiliar + "%"}{" "}
                            {/* 😇 */}
                          </span>
                        ) : tipoPresentismoFamiliar === "Amarillo" ? (
                          <span>
                            {porcentajePresentismoFamiliar === undefined
                              ? ""
                              : porcentajePresentismoFamiliar + "%"}{" "}
                            {/* 😐 */}
                          </span>
                        ) : (
                          <span>
                            {porcentajePresentismoFamiliar === undefined
                              ? ""
                              : porcentajePresentismoFamiliar + "%"}{" "}
                            {/* 😠 */}
                          </span>
                        )}
                      </p>
                    </div>
                  </>
                }
                customCss="ptur-presentismoBox-tooltip"
              />
            </div>
          </div>
        )}

      {habilitadoPresentismoPropio && authState?.auth?.data?.paciente?.ausentismo &&
        !(selectDropDownState.selectDropDown.selectGlobal.pacienteElegido &&
          showComponent) && (
          <div
            className={`${
              tipoPresentismo === "Verde"
                ? "ptur-presentismoBoxVerde-container"
                : tipoPresentismo === "Amarillo"
                ? "ptur-presentismoBoxAmarillo-container"
                : (bloqueoPresentismo &&
                    !authState.auth.data.paciente.seguimiento) ||
                  (!bloqueoPresentismo &&
                    authState.auth.data.paciente.seguimiento)
                ? "ptur-presentismoBoxRojo-container"
                : "ptur-presentismoBoxRojo-container"
            }  c-white`}
          >
            <div className="ptur-presentismoBox-texto1 rb14m">
              <div className="ptur-presentismo-txtIcon">
                Presentismo{" "}
                <div
                  onClick={modalInfoPresentismo}
                  className="ptur-presentismo-iconBox"
                >
                  <PresentismoAyudaIcon />
                </div>
              </div>
              <p>
                {tipoPresentismo === "Verde"
                  ? "¡Gracias por tu compromiso!"
                  : tipoPresentismo === "Amarillo"
                  ? "Tiene muchos ausentes sin cancelar"
                  : (bloqueoPresentismo &&
                      !authState.auth.data.paciente.seguimiento) ||
                    (!bloqueoPresentismo &&
                      authState.auth.data.paciente.seguimiento)
                  ? "No puedes solicitar turnos online"
                  : "Tiene muchos ausentes sin cancelar"}
              </p>
            </div>
            <div
              className="ptur-presentismoBox-texto2"
              onClick={modalTurnosPresentismo}
            >
              <Tooltip
                descripcion={"Ver Turnos"}
                data={
                  <>
                    <div className="porcentajeBox">
                      <p className="rb24b">
                        {tipoPresentismo === "Verde" ? (
                          <span>
                            {porcentajePresentismo === undefined
                              ? ""
                              : porcentajePresentismo === 0
                              ? "100%"
                              : porcentajePresentismo + "%"}{" "}
                            {/* 😇 */}
                          </span>
                        ) : tipoPresentismo === "Amarillo" ? (
                          <span>
                            {porcentajePresentismo === undefined
                              ? ""
                              : porcentajePresentismo + "%"}{" "}
                            {/* 😐 */}
                          </span>
                        ) : (
                          <span>
                            {porcentajePresentismo === undefined
                              ? ""
                              : porcentajePresentismo + "%"}{" "}
                            {/* 😠 */}
                          </span>
                        )}
                      </p>
                    </div>
                  </>
                }
                customCss="ptur-presentismoBox-tooltip"
              />
            </div>
          </div>
        )}
    </React.Fragment>
  );
};

export default PresentismoBox;
